import React, { useState } from 'react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../firebase';
import { useNavigate } from 'react-router-dom';

export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate('/');
    } catch (err) {
      setError('Invalid email or password');
      setLoading(false);
    }
  };

  return (
    <div style={wrapper}>
      <div style={card}>
        <h2 style={title}>Welcome Back 👋</h2>
        <p style={subtitle}>Please enter your login details below</p>

        <form onSubmit={handleLogin}>
          <div style={fieldGroup}>
            <label style={label}>Email</label>
            <input
              type="email"
              required
              onChange={(e) => setEmail(e.target.value)}
              style={input}
              placeholder="you@example.com"
            />
          </div>

          <div style={fieldGroup}>
            <label style={label}>Password</label>
            <input
              type="password"
              required
              onChange={(e) => setPassword(e.target.value)}
              style={input}
              placeholder="••••••••"
            />
          </div>

          {error && <p style={errorText}>{error}</p>}

          <button type="submit" disabled={loading} style={submitButton}>
            {loading ? <div style={spinner}></div> : 'Login'}
          </button>
        </form>
      </div>
    </div>
  );
}

const wrapper = {
  backgroundColor: '#f4f6f8',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '24px',
};

const card = {
  backgroundColor: '#fff',
  borderRadius: '16px',
  padding: '36px 28px', // ✅ horizontal padding for left & right
  width: '100%',
  maxWidth: '420px',
  boxShadow: '0 12px 30px rgba(0, 0, 0, 0.06)',
};


const title = {
  fontSize: '24px',
  fontWeight: 700,
  textAlign: 'center',
  marginBottom: '6px',
  color: '#111827',
};

const subtitle = {
  fontSize: '14px',
  textAlign: 'center',
  color: '#6b7280',
  marginBottom: '28px',
};

const fieldGroup = {
  marginBottom: '18px',
};

const label = {
  display: 'block',
  fontSize: '14px',
  fontWeight: 500,
  color: '#374151',
  marginBottom: '6px',
};

const input = {
  width: '100%',
  padding: '12px 14px',
  border: '1px solid #d1d5db',
  borderRadius: '10px',
  fontSize: '15px',
  backgroundColor: '#f9fafb',
  outline: 'none',
  boxSizing: 'border-box', // ✅ Fixes right-edge overflow
};

const submitButton = {
  width: '100%',
  padding: '12px',
  background: 'linear-gradient(to right, #2563eb, #3b82f6)',
  color: '#fff',
  border: 'none',
  borderRadius: '10px',
  fontSize: '16px',
  fontWeight: 600,
  cursor: 'pointer',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

const errorText = {
  color: '#dc2626',
  fontSize: '14px',
  marginTop: '-6px',
  marginBottom: '14px',
  textAlign: 'center',
};

const spinner = {
  width: '20px',
  height: '20px',
  border: '3px solid #fff',
  borderTop: '3px solid transparent',
  borderRadius: '50%',
  animation: 'spin 0.8s linear infinite',
};
